import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './switch-to-business.component.scss';
var SwitchToBusiness = /** @class */ (function (_super) {
    tslib_1.__extends(SwitchToBusiness, _super);
    function SwitchToBusiness(element) {
        return _super.call(this, element) || this;
    }
    SwitchToBusiness.prototype.init = function () { };
    SwitchToBusiness.prototype.bindEvents = function () { };
    return SwitchToBusiness;
}(Base));
export { SwitchToBusiness };



//////////////////
// WEBPACK FOOTER
// ./components/switch-to-business/switch-to-business.component.ts
// module id = 522
// module chunks = 0